import React, { useState } from "react";
import { HiOutlineEye, HiOutlineEyeOff } from "react-icons/hi";

import { formatCEP, formatCNPJ, formatCPFOrCNPJ } from "@/utils/cpfValidator";
import { formatCurrencyDigits } from "@/utils/currencyInput";

import { Button, Field, Footnote, HelperText, InputLabel, RequiredMark, TextField } from "./styles";
import { TextFieldProps } from "./types";

const TextFieldComponent = ({
  disabled = false,
  error = false,
  password = false,
  label,
  footnote,
  footnoteError = false,
  helpText,
  placeholder,
  type,
  required = false,
  optional = false,
  labelPosition = "floating",
  mask,
  onChange,
  ...props
}: TextFieldProps) => {
  const [showPassword, setShowPassword] = useState(!password);
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (mask === "currency") {
      const value = formatCurrencyDigits(event.target.value);
      onChange?.({
        ...event,
        target: { ...event.target, value },
        currentTarget: { ...event.currentTarget, value },
      } as React.ChangeEvent<HTMLInputElement>);
      return;
    }

    if (mask === "cnpj") {
      const value = formatCNPJ(event.target.value);
      onChange?.({
        ...event,
        target: { ...event.target, value },
        currentTarget: { ...event.currentTarget, value },
      } as React.ChangeEvent<HTMLInputElement>);
      return;
    }

    if (mask === "cpf-cnpj") {
      const value = formatCPFOrCNPJ(event.target.value);
      onChange?.({
        ...event,
        target: { ...event.target, value },
        currentTarget: { ...event.currentTarget, value },
      } as React.ChangeEvent<HTMLInputElement>);
      return;
    }

    if (mask === "cep") {
      const value = formatCEP(event.target.value);
      onChange?.({
        ...event,
        target: { ...event.target, value },
        currentTarget: { ...event.currentTarget, value },
      } as React.ChangeEvent<HTMLInputElement>);
      return;
    }

    onChange?.(event);
  };
  return (
    <div>
      <Field $labelPosition={labelPosition}>
        {labelPosition === "top" && (
          <InputLabel $error={error} $labelPosition="top">
            {label}
            {required && <RequiredMark aria-hidden="true">*</RequiredMark>}
            {optional && <span className="ml-1 text-gray-400">(opcional)</span>}
          </InputLabel>
        )}
        <TextField
          disabled={disabled}
          $error={error}
          $labelPosition={labelPosition}
          required={required}
          {...props}
          onChange={handleChange}
          placeholder={placeholder || " "}
          type={password ? (showPassword ? "text" : "password") : type || "text"}
        />
        {labelPosition !== "top" && <InputLabel $error={error}>{label}</InputLabel>}

        {password && (
          <Button onClick={() => setShowPassword(!showPassword)}>
            {!showPassword ? <HiOutlineEyeOff size={30} /> : <HiOutlineEye size={30} />}
          </Button>
        )}
      </Field>
      {footnote && <Footnote $error={footnoteError}>{footnote}</Footnote>}
      {helpText && <HelperText $error={error}>{helpText}</HelperText>}
    </div>
  );
};

export default TextFieldComponent;
